/**
 * Static marketing content for Landing v2. Photo assets are served from
 * /public/marketing/landing-v2.
 */

export const ASSET_BASE = '/marketing/landing-v2'

export const photo = (name: string) => `${ASSET_BASE}/${name}.jpg`

export interface MarqueeAlbum {
  name: string
  meta: string
  dot: string
}

export const marqueeAlbums: MarqueeAlbum[] = [
  { name: 'Elena & Marcus', meta: '214 PHOTOS · 12 INSIDE', dot: '#ffcf7d' },
  { name: 'June, Year One', meta: 'GRANDMA VISITED TODAY', dot: '#fea67d' },
  { name: 'Leo turns 30', meta: '3 NEW COMMENTS', dot: '#be9dfd' },
  { name: 'The Dolomites', meta: 'WALKABLE ◈', dot: '#01dafe' },
  { name: 'Amalfi, July', meta: 'ONE YEAR AGO THIS WEEK', dot: '#e7f09a' },
]

export const ledgerRows = [
  { key: 'Your 24.6MP original', value: 'KEPT · 24.6MP' },
  { key: '"Storage saver" downgrades', value: 'NOT A FEATURE', tone: 'bad' as const },
  { key: 'Guest downloads', value: 'THE REAL FILE' },
  { key: 'Free plan resolution', value: 'ALSO FULL — ALWAYS' },
]

export const threadRows = [
  { avatar: 'S', tone: '#ffcf7d', ink: '#4a3510', text: '<b>Sarah</b> pinned a note on <b>photo 14</b>', time: 'NOW' },
  { avatar: 'T', tone: '#be9dfd', ink: '#2d1a54', text: '<b>Theo</b> left a <b>voice note</b> · 0:12', time: '2M' },
  { avatar: 'G', tone: '#01dafe', ink: '#05323b', text: '<b>Grandma</b> is viewing right now', time: 'LIVE' },
]

export const beats = [
  {
    no: 'BEAT 1 — PRINT',
    title: 'The key card sits on the table.',
    body: 'Designed table tents, invite inserts, and print-backs — not a QR slapped on a page.',
  },
  {
    no: 'BEAT 2 — SCAN',
    title: 'Five seconds, no app store.',
    body: "Guests scan and they're inside on any device. No account. To speak, they leave a first name — that's the whole gate.",
  },
  {
    no: 'BEAT 3 — INSIDE',
    title: 'They arrive somewhere.',
    body: 'Not a grid of thumbnails — a lit room with a nameplate, presence, and the night\u2019s photos on the walls.',
  },
]

export const proofStats = [
  { value: 38, suffix: '%', label: 'of guests react, comment, or contribute', source: 'VS ~4% ON FEEDS' },
  { value: 3.2, suffix: '×', decimals: 1, label: 'more return visits than link-in-bio galleries', source: 'SAME ALBUMS, A/B' },
  { value: 5, suffix: 's', label: 'from QR scan to standing inside', source: 'MEDIAN, MOBILE' },
  { value: 0, suffix: '', label: 'accounts your guests will ever be forced to create', source: 'POLICY, NOT METRIC' },
]
